<div class="chart-wrapper">
    <div class="canvas-wrapper">
        <canvas #debtChart></canvas>
    </div>
</div>